import React, { useState } from 'react';
import './Style.css';
import Moringa from '../../assets/Slider/moringaLeafPowder.jpg';
import Banana from '../../assets/Slider/bananaPowder.jpg';
import ABCMalt from '../../assets/Slider/abcCover.jpg';
import GarlicFlakes from '../../assets/Slider/garlicFlakes.jpg';
import GarlicPowder from '../../assets/Slider/garlicPowder.jpg';
import OnionPowder from '../../assets/Slider/onionPowderCover.jpg';
import Spices from '../../assets/Slider/spices.jpg';

const Home = () => {
  const images = [
    Moringa,
    OnionPowder,
    Banana,
    ABCMalt,
    GarlicPowder,
    GarlicFlakes,
    Spices
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="slider-container">
      <button className="arrow left-arrow" onClick={prevSlide}>
        &#9664;
      </button>

      <div className="slider-wrapper">
        <img
          src={images[currentIndex]}
          alt={`Slide ${currentIndex}`}
          className="slider-image"
        />
      </div>

      <button className="arrow right-arrow" onClick={nextSlide}>
        &#9654;
      </button>
    </div>
  );
};

export default Home;
